import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const PERIODS = [[7, "7 giorni"], [30, "30 giorni"], [0, "Da sempre"]];
const COLS = [["applications", "Candidature"], ["approved", "Approvate"], ["contracts_sent", "Contratti inviati"], ["signed", "Firmati"], ["pending", "In attesa di firma"], ["conversion", "Conversione"]];

const Totals = ({ rows }) => (
  <div data-testid="stats-totals" className="grid grid-cols-2 gap-px bg-[#1c1418]/15 sm:grid-cols-5">
    {COLS.slice(0, 5).map(([k, l]) => (
      <div key={k} className="bg-white p-4 last:col-span-2 sm:last:col-span-1">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#1c1418]/70">{l}</p>
        <p data-testid={`stats-total-${k}`} className="font-display text-5xl leading-none">{rows.reduce((s, r) => s + (r[k] ?? 0), 0)}</p>
      </div>
    ))}
  </div>
);

const AgentRow = ({ a }) => (
  <li data-testid={`stats-row-${a.ref}`} className="grid grid-cols-2 gap-3 py-5 sm:grid-cols-7 sm:items-center">
    <p className="col-span-2 font-display text-3xl uppercase leading-none sm:col-span-1">{a.name}</p>
    {COLS.map(([k, l]) => (
      <div key={k}>
        <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-[#1c1418]/70 sm:hidden">{l}</p>
        <p data-testid={`stats-${a.ref}-${k}`} className={`font-display text-3xl leading-none ${k === "pending" && a.pending ? "text-[#e9458f]" : ""}`}>
          {a[k] ?? 0}{k === "conversion" ? "%" : ""}
        </p>
      </div>
    ))}
  </li>
);

export const StatsPanel = () => {
  const [days, setDays] = useState(30);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(`/admin/agents/stats?days=${days}`).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => toast.error("Errore nel caricamento"));
  }, [days]);

  return (
    <div data-testid="stats-panel" className="space-y-8">
      <div className="flex flex-wrap gap-2">
        {PERIODS.map(([d, l]) => (
          <button key={d} onClick={() => setDays(d)} data-testid={`stats-period-${d}`}
            className={`border px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] transition-colors ${days === d ? "border-[#1c1418] bg-[#1c1418] text-white" : "border-[#1c1418]/30 hover:border-[#1c1418]"}`}>{l}</button>
        ))}
      </div>
      <Totals rows={rows} />
      <div>
        <div className="hidden grid-cols-7 gap-3 border-b border-[#1c1418] pb-2 font-mono text-[11px] uppercase tracking-[0.15em] text-[#1c1418]/70 sm:grid">
          <span>Agente</span>{COLS.map(([k, l]) => <span key={k}>{l}</span>)}
        </div>
        <ul className="divide-y divide-[#1c1418]/15 border-b border-[#1c1418]/15">
          {rows.map((a) => <AgentRow key={a.id} a={a} />)}
        </ul>
        <p className="mt-3 text-xs text-[#1c1418]/70">"In attesa di firma" conta tutti i contratti ancora da firmare, indipendentemente dal periodo. Conversione = firmati ÷ candidature.</p>
      </div>
    </div>
  );
};
